<template>
  <div class="row">
    <div class="col order-summary-toggle d-block d-none-md w-100">
      <button class="btn btn-block btn-show" @click="toggleOrderSummary">
        Show order summary
        <i class="fa fa-caret-down"></i>
      </button>

      <div :class="['container p0', shouldShowOrderSummary ? 'show' : '']">
        <div class="cart--side">
          <cart-review />
        </div>
      </div>
    </div>

    <ValidationObserver
      ref="formObserver"
      tag="form"
      class="col-lg-7 mb50-md mb20 pr30-lg"
      @submit.prevent="onSubmit"
    >
      <loader :loading="loading"></loader>
      <checkout-breadcrumbs />

      <contact-info-summary />

      <section class="delivery--block mb30-md mb20">
        <h2 class="main-title tc-custom-red fs22 m0 pb20 bb-lightgray">Shipping</h2>

        <ValidationProvider
          :rules="{ required: shippingMethods.length > 0 }"
          name="Shipping"
          tag="div"
          class="form-group"
          v-slot="{ errors }"
        >
          <template v-if="shippingMethods.length > 0">
            <div
              v-for="(shippingMethod, index) in shippingMethods"
              :key="index"
              class="custom-control custom__radio px0 py15 bb-lightgray"
            >
              <input
                type="radio"
                :id="shippingMethod.slug"
                name="shippingMethod"
                class="custom-control-input"
                :value="shippingMethod.id"
                v-model="selectedShippingMethod"
              />
              <label
                class="custom-control-label d-flex align-items-center"
                :for="shippingMethod.slug"
              >
                {{ shippingMethod.title }} ({{ shippingMethod.description }})
                <span
                  v-if="shippingMethod.fee.amount > 0"
                  class="ff-nunito-bold ml-auto mr20"
                >
                  {{ shippingMethod.fee | moneyToCurrencyFormat }}
                </span>
                <span v-else class="ff-nunito-bold ml-auto mr20">
                  FREE
                </span>
              </label>
            </div>
          </template>
          <div
            v-else
            class="custom-control custom__radio px0 py15 bb-lightgray"
          >
            <input
              type="radio"
              id="free"
              name="shippingMethod"
              class="custom-control-input"
              value=""
              v-model="selectedShippingMethod"
            />
            <label
              class="custom-control-label d-flex align-items-center"
              for="free"
            >
              FREE
            </label>
          </div>
          <span v-if="errors.length > 0" class="label--error text-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </section>

      <section
        class="action-btn d-flex align-items-center justify-content-between flex-sm-row flex-column-reverse mt30-md mt20"
      >
        <div>
          <router-link class="main-link" :to="{ name: 'information' }">
            &#60; Return to Information
          </router-link>
        </div>
        <div class="main-btn px0">
          <button type="submit">
            Continue to Payment
          </button>
        </div>
      </section>
    </ValidationObserver>

    <div class="col-lg-5 cart--side pt10">
      <cart-review />
    </div>
  </div>
</template>

<script>
import CheckoutBreadcrumbs from "../components/checkout/CheckoutBreadcrumbs";
import ContactInfoSummary from "../components/checkout/ContactInfoSummary";
import CartReview from "../components/checkout/CartReview";
import Loader from "../components/Loader";
import checkout from "../api/checkout";
import shippingMethod from "../api/shippingMethod";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    CheckoutBreadcrumbs,
    ContactInfoSummary,
    CartReview,
    Loader,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      loading: false,
      shouldShowOrderSummary: false,
      shippingMethods: []
    };
  },
  computed: {
    contactNumber() {
      return this.$store.state.checkout.contact.contactNumber;
    },
    shippingAddress() {
      return this.$store.getters["checkout/fullShippingAddress"];
    },
    selectedShippingMethod: {
      get() {
        return this.$store.state.checkout.shipping.method;
      },
      set(value) {
        const shippingMethodData = this.shippingMethods.find(
          item => item.id === value
        );

        this.$store.commit("checkout/UPDATE_SHIPPING_METHOD", value);
        this.$store.commit(
          "checkout/UPDATE_SHIPPING_FEE",
          shippingMethodData.fee
        );
      }
    }
  },
  async activated() {
    this.loading = true;
    this.shippingMethods = [];

    const {
      data: { is_free_shipping }
    } = await checkout.checkFreeShipping(
      this.$store.getters["checkout/paymentPayload"]
    );

    if (!is_free_shipping) {
      const {
        data: { shipping_methods }
      } = await shippingMethod.all();

      this.shippingMethods = shipping_methods;
    }

    this.loading = false;
  },
  methods: {
    async onSubmit(event) {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) {
        return;
      }

      this.$store.commit("checkout/UPDATE_STEP_COMPLETED", "shipping");

      return this.$router.push({ name: "payment" });
    },
    toggleOrderSummary() {
      this.shouldShowOrderSummary = !this.shouldShowOrderSummary;
    }
  }
};
</script>

<style></style>
